<template>
  <div id="app">
    <Navlist></Navlist>
    <!-- <div style="height: 248px;" class="topDiv"></div> -->
    <router-view/>
		<Bottom></Bottom>
    <Shares></Shares>
  </div>
</template>

<script>
import Navlist from '@/components/common/navlist'
import Bottom from '@/components/common/bottom'
import Shares from '@/components/common/shares'
export default {
  name: 'App',
	components:{
		Navlist,
		Bottom,
    Shares
	},
  data(){
    return{
			AppLang: ''
    }
  },
	mounted(){
		
		this.AppLang = sessionStorage.getItem('locale');
		
		
	},
  methods:{
    // watchScroll () {
    //         var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //         //  当滚动超过 50 时，实现吸顶效果
    //         if (scrollTop > 49) {
    //           this.navBarFixed = true
    //         } else {
    //           this.navBarFixed = false
    //         }
    //      }
		
  }
}
</script>

<style>
::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: rgba(210, 210, 210, 0.48);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 0;
}
::-webkit-scrollbar-thumb {
    background-color: #c6c6c6;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 0;
}
body{
	padding: 0;
	margin: 0;
  background: #f0f0f0;
}
ul{
	padding: 0;
	margin: 0;
}
ul li{
	list-style: none;
}
h2,h3,h4,h5,h6{
  margin: 0;
  text-align: left;
  font-weight: normal;
}
h2{
  font-size: 24px;
  color: #6b6b6b;
}
h3{
  font-size: 18px;
  color: #aeaeae;
}
span{
  text-align: left;
}
p{
  text-align: left;
  margin: 0;
  text-align: justify;
}
img{
  width: 100%;
  display: block;
}
#app {
  font-family: 'microsoft yahei','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #101010;
}
.container{
  width: 1200px;
  margin: 0 auto;
	box-sizing: border-box;
}
.ellipsis{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
}
.main-banner{
	position: relative;
	height: 500px;
	overflow: hidden;
}
.banner-title{
	width: 80%;
	max-width: 1200px;
	background: #FFFFFF;
	padding: 25px 0;
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	border: 1px solid #e3e3e3;
}
.banner-title h2,.banner-title h3{
	text-align: center;
}
@media (max-width: 1200px){
	.container{
		width: 992px;
	}
}
@media (max-width: 992px){
  .topDiv{
    height: 100px!important;
  }
	.container{
	  width: 100%;
	  max-width: none;
	  margin: 0 auto;
		padding: 0 20px;
	}
	h2,h3{
		text-align: center;
	}
	.main-banner{
		height: 200px;
	}
  .banner-title{
    width: 100%;
		display: none;
  }
  .banner-title h2{
    font-size: 20px;
  }
	.swiper-button-prev,.swiper-button-next{
		display: none !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue